// @ts-nocheck
import React, {useMemo , useEffect} from 'react'
import {useDropzone} from 'react-dropzone'
import { useBody } from '../../../../Body/state/BodyContext';
import baseStyle from '../../../../styles/AdjuntosStyle';



const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#4caf50'
};

const rejectStyle = {
  borderColor: '#cc0000'
};

export default function DropZone (props) {
    const {setMessage} = useBody();
    const {customValidator , maxSize , pesoAcumulado , archivosAceptados , setProgress , setPesoAcumulado  , setArchivos } = props;

    const {
        acceptedFiles,
        fileRejections,
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
      } = useDropzone({
          accept: archivosAceptados, //consultar extensiones permitidas
          noClick: true,
          validator: customValidator
    });


    const style = useMemo(() => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }), [
      isDragActive,
      isDragReject,
      isDragAccept
    ]);


    useEffect(()=>{
        setArchivos(acceptedFiles);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[acceptedFiles])

    useEffect(()=>{
      if(fileRejections.length > 0) {
        fileRejections.forEach((element, index) => {
            setMessage(fileRejections[index].errors[0].error);
          });
      }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      },[fileRejections])


    return(
        // <div className="container">
            <div {...getRootProps({style})}>
                <input {...getInputProps()} />
                <p><b>Arrastrar archivos</b></p>
            </div>
        // </div>
    )
}